import { defineStore } from 'pinia'
import { Assert, lazyRef } from '@previo/core'
import { Context, UserId, useFeatureFlags } from '@previo/feature-flags'
import { useAPI } from '~/http'
import { User } from '~/store/user/model/User'
import { StoreKey } from '~/store/StoreKey'

const { userAPI } = useAPI()

export const useUserStore = defineStore(StoreKey.USER, () => {
  const loadUser = async (): Promise<User> => {
    const user = User.fromResponseData(await userAPI.load())

    Assert.notNull(user.id)

    useFeatureFlags().appendContext(new Context([new UserId(user.id)]))

    return user
  }

  const user = lazyRef(loadUser, User.empty())

  return {
    user,
    loaded: user.isLoaded,
    load: user.load,
    reload: user.reload,
  }
})
